import React from 'react';
import PropTypes from 'prop-types';
import { default as PartnerMediaModel } from '../../models/partnerMedia';
import PartnerMedia from './media';

const PartnerMediaList = ({ organization, medias, updateImage, acceptedMedias = ['logo', 'banner'] }) => {
    return (
        <>
            {acceptedMedias.map(type => (
                <PartnerMedia
                    key={type}
                    organization={organization}
                    type={type}
                    media={Array.isArray(medias) ? medias.find(media => media.type === type) || new PartnerMediaModel() : medias[type] || new PartnerMediaModel()}
                    updateImage={updateImage}
                />
            ))}
        </>
    );
};

export default PartnerMediaList;
PartnerMediaList.propTypes = {
    organization: PropTypes.object.isRequired,
    medias: PropTypes.array.isRequired,
    updateImage: PropTypes.func.isRequired,
    acceptedMedias: PropTypes.array
};
